import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    Box,
    Text,
    Flex,
    Divider,
} from '@chakra-ui/react';
import { ReactComponent as InvitationIcon } from 'assets/notification-invitation-icon.svg';

interface OwnProps {
    isOpen: boolean;
    onClose: () => void;
    walletName: string;
    walletAccountId: string;
    onJoin: () => void;
    isLoading?: boolean;
}

const WelcomeWalletModal = ({ isOpen, onClose, walletName, walletAccountId, onJoin, isLoading }: OwnProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent maxWidth="480px">
                <ModalHeader textAlign="center" pt={8}>
                    <Text size="xl" variant="bodyBold">
                        Wallet Invitation
                    </Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody pb={8} px={8}>
                    <Flex direction="column" gap={6} alignItems="center">
                        <Flex
                            alignItems="center"
                            justifyContent="center"
                            w={16}
                            h={16}
                            borderRadius="full"
                            bg="blue.50"
                        >
                            <InvitationIcon width={32} height={32} />
                        </Flex>

                        <Box textAlign="center">
                            <Text color="blackAlpha.600" mb={1}>
                                You have been added as a signer to
                            </Text>
                            <Text size="lg" variant="bodyBold">
                                {walletName}
                            </Text>
                        </Box>

                        <Divider />

                        <Box w="full" bg="primary" p={4} borderRadius={8}>
                            <Text size="xs" color="blackAlpha.600" mb={1}>
                                WALLET ADDRESS
                            </Text>
                            <Text size="sm" variant="bodyBold">
                                {walletAccountId}
                            </Text>
                        </Box>

                        <Text fontSize="xs" color="blackAlpha.500" textAlign="center">
                            You are now a signer on this multisig wallet. Click below to open the dashboard and start managing transactions.
                        </Text>

                        <Button
                            variant="primary"
                            w="full"
                            h="48px"
                            onClick={onJoin}
                            isLoading={isLoading}
                            loadingText="Joining..."
                        >
                            Open Wallet
                        </Button>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default WelcomeWalletModal;
